module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "welcome-image"
  }, [_c('a', {
    attrs: {
      "href": "#/prologue"
    }
  }, [_c('img', {
    attrs: {
      "alt": "CoverImage",
      "src": "images/9780446574907_c.jpg",
      "title": "Cover"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('a', {
    attrs: {
      "href": "#/prologue"
    }
  }, [_c('b', [_vm._v("Begin Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/toc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/teaser001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of “MONTANA LEGACY”")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/teaser002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of “MONTANA DESTINY”")])]), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84bf9140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome.vue
// module id = 60
// module chunks = 0